import { INSTAGRAM } from '@/lib/socialProfile';
import { ProfileActivityInstagram, requestInstagramParams } from './instagram';

export const ProfileActivityConfig = (type) => {
    let config;
    let fields;
    let parameters;
    switch (type) {
        case INSTAGRAM:
            config = ProfileActivityInstagram;
            fields = requestInstagramParams;
            break;
    }
    return { config, fields, parameters };
};
